<script lang="ts">
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Mousewheel } from "swiper";
  import "swiper/css";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";
  import CareerDepartmentsSliderItem from "./CareerDepartmentsSliderItem.svelte";

  export let jobs: any;
  export let customOrder: any;

  const customSort = (a, b) => {
    const indexA = customOrder.indexOf(a);
    const indexB = customOrder.indexOf(b);
    if (indexA === -1) {
      return 1;
    }
    if (indexB === -1) {
      return -1;
    }
    return indexA - indexB;
  };
  $: departments = jobs
    ? [...new Set(jobs.map((j) => j.departments[0].name))].sort(customSort)
    : [];

  let slider;
  $: isBeginning = true;
  $: isEnd = false;

  function swiperReady(e) {
    slider = e.detail[0];
  }
  function slidePrev() {
    slider.slidePrev();
  }
  function slideNext() {
    slider.slideNext();
  }
</script>

{#if departments.length > 0}
  <div class="max-w-[100vw] overflow-visible">
    <Swiper
      on:swiper={swiperReady}
      on:progress={async (e) => {
        isBeginning = slider?.isBeginning;
        isEnd = slider?.isEnd;
      }}
      navigation
      breakpoints={{
        0: { slidesPerView: 1.15 },
        600: { slidesPerView: 2.15 },
        1024: { slidesPerView: 3.15 },
      }}
      modules={[Mousewheel]}
      mousewheel={{
        releaseOnEdges: true,
        forceToAxis: true,
      }}
      spaceBetween={24}
      slidesPerView={3}
      preventClicks={true}
      preventClicksPropagation={true}
      shortSwipes={false}
      longSwipesRatio={0.2}
      longSwipesMs={20}
      threshold={10}
      class="!overflow-visible"
    >
      {#each departments as d}
        <SwiperSlide class="flex flex-col">
          <CareerDepartmentsSliderItem name={d} {jobs} />
        </SwiperSlide>
      {/each}
    </Swiper>

    <div class="hidden md:flex mt-[50px] md:mt-[75px] justify-between">
      <div class="hidden sm:block">
        <Button href="/careers/open-roles" color={ButtonColor.BLACK}
          ><div class="text-[12px]">SEE ALL ROLES</div></Button
        >
      </div>
      <div class="flex gap-2.5 justify-end">
        <div
          class="transition-opacity duration-150"
          style={`${isBeginning ? "opacity:0.3;pointer-events:none;" : ""}`}
        >
          <Button
            icon={IconType.ARROW_LEFT_LARGE}
            color={ButtonColor.GRAY}
            reduced
            on:click={slidePrev}
            iconLeft={false}
          />
        </div>
        <div
          class="transition-opacity duration-150"
          style={`${isEnd ? "opacity:0.3;pointer-events:none;" : ""}`}
        >
          <Button
            icon={IconType.ARROW_RIGHT_LARGE}
            color={ButtonColor.GRAY}
            reduced
            on:click={slideNext}
          />
        </div>
      </div>
    </div>
  </div>
{/if}
